import { render, staticRenderFns } from "./insassetquery.vue?vue&type=template&id=6966b487&scoped=true&"
import script from "./insassetquery.vue?vue&type=script&lang=js&"
export * from "./insassetquery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966b487",
  null
  
)

export default component.exports